import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b55e06f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component-oc-record" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "cell" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "cell" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "cell" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "barcode-list" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "vlaue" }

import { onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { request } from '@/utils';
  import { IUserRequest } from '@/types/user-request';
  import { Collection } from '@/stores';

  interface IProps {
    type: 'PDO' | 'OfflineCollection';
    title: string;
    collectionMethod?: string;
    collectionState?: string;
  }
  interface OCUserRequestStore extends Collection {
    data: IUserRequest[];
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    title: null,
    collectionMethod: null,
    collectionState: null
  },
  setup(__props: any) {

const props = __props as {
    type: 'PDO' | 'OfflineCollection';
    title: string;
    collectionMethod?: string;
    collectionState?: string;
  }

  
  const requestNameSourceMap = {
    'PDO': 'pdos',
    'OfflineCollection': 'offline_collections'
  };

  const { t } = useI18n();
  const route = useRoute();
  const store = Collection.create<OCUserRequestStore>({
    fetch(params = {}) {
      return request.get(`/${requestNameSourceMap[props.type]}/${route.params.id}/user_requests`, { params });
    }
  });

  onMounted(() => {
    store.fetchData();
  });

  const handlePageChange = (page: any) => {
    store.params.page = page;
    store.fetchData();
  };

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(props.title), 1),
      (props.type === 'OfflineCollection' && props.collectionMethod !== 'user_registration' && __props.collectionState === 'active')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "new-button",
            to: { name: 'mine.offline_collections.detail.new', params: { id: _unref(route).params.id }, query: { title: props.title } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('offline_collection.record.New Submission')), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(store).isEmpty)
      ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "item-card"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('offline_collection.record.Name')), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.user.screen_name), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('offline_collection.record.Created at')), 1),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_AppTimeFormat, {
                time: item.created_at,
                format: "YYYY-MM-DD HH:mm:ss"
              }, null, 8, ["time"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('offline_collection.record.Bin Name')), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(item.collection_bin ? item.collection_bin.name : ''), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('offline_collection.record.Barcode')), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.collected_items, (collected, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "barcode"
              }, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(i + 1) + ". ", 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(collected.barcode), 1)
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    (_unref(store).meta.total_pages > 1)
      ? (_openBlock(), _createBlock(_component_AppPagination, {
          key: 1,
          total: _unref(store).meta.total,
          "per-page": _unref(store).meta.per_page,
          page: _unref(store).meta.page,
          onChange: handlePageChange
        }, null, 8, ["total", "per-page", "page"]))
      : _createCommentVNode("", true)
  ]))
}
}

})